/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MailNodeNotificationType {
    Base = '0',
    Email = 1,
}
